import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { H5 } from '../../../../AbstractElements';
import { DailyDropdown, Visitors } from '../../../../Constant';
import { OptionsVisitorChartWidget } from '../../../../Data/Ecommerce/Chart';
import SvgIcon from '../../../Common/Component/SvgIcon';
import DropdownCommon from '../../../Common/Dropdown';
import axios from 'axios';
import config from '../../../../config';
import { useTranslation } from 'react-i18next';


const TrafficByDay = ({ propertyId, floor, zone, entrance, device }) => {

    const { t } = useTranslation();
    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [labels, setLabels] = useState(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);
    const [thisWeekData, setThisWeekData] = useState([]);
    const [lastWeekData, setLastWeekData] = useState([]);

    useEffect(() => {
            const data = {
                concessionaire_id,
                property_access:property_access,
                property_id: propertyId,
                ...(floor && { floor }),
                ...(zone && { zone }),
                ...(entrance && { entrance_name: entrance }),
                ...(device && { device_name: device }),
                //timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            };
    
            axios
                .post(`${config.hostname}/trafficdashboard/getweeklytrafficcomparison`, data, configheader)
                .then((response) => {
                    setLabels(response.data.labels);
                    setThisWeekData(response.data.thisWeekData);
                    setLastWeekData(response.data.lastWeekData);
                })
                .catch((error) => {
                    console.error(error);
                });
    
        }, [propertyId, floor, zone, entrance, device]);

    // get dynamic max value for y-axis
    const getDynamicMax = () => {
        const combined = [...thisWeekData, ...lastWeekData];
        if (combined.length === 0) return 100; // fallback
        const maxVal = Math.max(...combined);
        return Math.ceil(maxVal * 1.1); // add 10% padding
    };    
    
    const OptionsVisitorChartWidget = {
        series: [
            {
                name: t("This Week"),
                data: thisWeekData,//[534, 140, 235, 189, 128, 107, 489],
            },
            {
                name: t("Last Week"),
                data: lastWeekData,//[620, 164, 340, 230, 115, 145, 445],
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: 270,
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "50%",
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 6,
                colors: ["transparent"],
            },
            grid: {
                show: true,
                borderColor: "var(--chart-border)",
                xaxis: {
                    lines: {
                        show: true,
                    },
                },
            },
            colors: ["#4caaf0", "var(--theme-default)"],
            xaxis: {
                categories: labels,//["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",],
                tickAmount: 4,
                tickPlacement: "between",
                labels: {
                    style: {
                        fontFamily: "Rubik, sans-serif",
                    },
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                min: 0,
                max: getDynamicMax(),
                tickAmount: 5,
                tickPlacement: "between",
                labels: {
                    style: {
                        fontFamily: "Rubik, sans-serif",
                    },
                },
            },
            fill: {
                opacity: 1,
            },
            legend: {
                position: "top",
                horizontalAlign: "left",
                fontFamily: "Rubik, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                labels: {
                    colors: "var(--chart-text-color)",
                },
                markers: {
                    width: 6,
                    height: 6,
                    radius: 12,
                },
                itemMargin: {
                    horizontal: 10,
                },
            },
            responsive: [
                {
                    breakpoint: 1366,
                    options: {
                        plotOptions: {
                            bar: {
                                columnWidth: "80%",
                            },
                        },
                        grid: {
                            padding: {
                                right: 0,
                            },
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        plotOptions: {
                            bar: {
                                columnWidth: "50%",
                            },
                        },
                        grid: {
                            padding: {
                                right: 0,
                            },
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        plotOptions: {
                            bar: {
                                columnWidth: "60%",
                            },
                        },
                        grid: {
                            padding: {
                                right: 5,
                            },
                        },
                    },
                },
            ],
        },
    };


    return (
        <Card className='visitor-card'>
            <CardHeader className='card-no-border pb-0'>
                <div className='header-top'>
                    <H5 attrH5={{ className: 'm-0' }}>
                        {t('Traffic By week')}
                        <span className='f-14 font-primary f-w-500 ms-1'>
                            <SvgIcon iconId='user-visitor' className='svg-fill me-1' />
                            {/* (+2.8) */}
                        </span>
                    </H5>
                    <div className='card-header-right-icon'>
                        <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown.map((item) => t(item))} iconName='icon-more-alt' btn={{ tag: 'span' }} />
                    </div>
                </div>
            </CardHeader>
            <CardBody className='pt-3'>
                <div className='visitors-container'>
                    <ReactApexChart height={270} type='bar' options={OptionsVisitorChartWidget.options} series={OptionsVisitorChartWidget.series} />
                </div>
            </CardBody>
        </Card>
    )
}

export default TrafficByDay